<template>
  <div>
    <div class="animates-items mb16">
      <div class="checkbox_colorPicker_container">
        <span>阴影</span>
        <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
      </div>
      <box-shadow
        :boxShadowH.sync="boxShadowH"
        :boxShadowV.sync="boxShadowV"
        :boxShadowBlur.sync="boxShadowBlur"
        :boxShadowSpread.sync="boxShadowSpread"
        :boxShadowColor.sync="boxShadowColor"
      />
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "borderRadius-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    borderVariable: {
      get() {
        if (!this.animateDataVal.aboxShadow || JSON.stringify(this.animateDataVal.aboxShadow) === "{}") {
          // let options = JSON.parse(JSON.stringify(this.options))
          this.animateDataVal.aboxShadow = {
            boxShadowH: [0],
            boxShadowV: [0],
            boxShadowBlur: [0],
            boxShadowSpread: [0],
            boxShadowColor: ["rgba(0,0,0,0)"]
          }
        }
        return this.animateDataVal.aboxShadow
      }
    },
    boxShadowH: {
      get() {
        return this.borderVariable.boxShadowH
      },
      set(newVal) {
        this.$set(this.borderVariable, "boxShadowH", newVal)
        // this.getBoxShadowStyle()
      }
    },
    boxShadowV: {
      get() {
        return this.borderVariable.boxShadowV
      },
      set(newVal) {
        this.$set(this.borderVariable, "boxShadowV", newVal)
        // this.getBoxShadowStyle()
      }
    },
    boxShadowBlur: {
      get() {
        return this.borderVariable.boxShadowBlur
      },
      set(newVal) {
        this.$set(this.borderVariable, "boxShadowBlur", newVal)
        // this.getBoxShadowStyle()
      }
    },
    boxShadowSpread: {
      get() {
        return this.borderVariable.boxShadowSpread
      },
      set(newVal) {
        this.$set(this.borderVariable, "boxShadowSpread", newVal)
        // this.getBoxShadowStyle()
      }
    },
    boxShadowColor: {
      get() {
        if(this.borderVariable.boxShadowColor?.indexOf("inset") > -1){
          return this.borderVariable.boxShadowColor.replace("inset","")
        }
        return this.borderVariable.boxShadowColor
      },
      set(newVal) {
        this.$set(this.borderVariable, "boxShadowColor", newVal)
        // this.getBoxShadowStyle()
      }
    }
  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getBoxShadowStyle() {
      let curBoxShadow = this.borderVariable
      let triggerType = this.animateDataVal.triggerType

      let tmpStyle = ""
      curBoxShadow.boxShadowH.forEach((item, index) => {
        if (index > 0) {
          tmpStyle += ","
        }
        tmpStyle += `${curBoxShadow.boxShadowH[index]}px ${curBoxShadow.boxShadowV[index]}px ${curBoxShadow.boxShadowBlur[index]}px ${curBoxShadow.boxShadowSpread[index]}px ${curBoxShadow.boxShadowColor[index]}`
      })
      this.animateDataVal.variable[
        `${triggerType}OrgBorderRadius`
      ] = `var_borderOrgRadius_borderTopLeftRadius,borderTopRightRadius,borderBottomRightRadius,borderBottomLeftRadius_px`
      this.animateDataVal.variable[`${triggerType}BoxShadow`] = tmpStyle
    }
  },
  beforeDestroy() {
    this.getBoxShadowStyle()
  }
})
</script>

<style lang="scss" scoped></style>
